<template>
  <div>
    <el-dialog
      v-if="showModel"
      :visible="showModel"
      center
      append-to-body
      :close-on-click-modal="false"
      width="1200px"
      :before-close="initSumbit"
      :title="!disabled ? '处理' : '详情'"
    >
      <div class="form-area" v-loading="loading">
        <div class="form-title">
          <div class="tab">
            <div
              class="tab-item"
              :class="{ active: tabIndex == index }"
              @click="tabClick(index)"
              :key="index"
              v-for="(item, index) in tabArr"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <Form
          v-show="tabIndex == 0"
          :disabled="disabled"
          :model="model"
          :label-width="100"
          label-position="right"
          :rules="rules"
          ref="form"
          inline
        >
          <FormItem :class="{ 'model-hidden': true }" label="文本框">
            <Input v-model="model.id" type="text"></Input>
          </FormItem>
          <Row>
            <Col span="8">
              <FormItem label="户名" prop="hm">
                <Input
                  v-model="model.hm"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="户号" prop="hh">
                <Input
                  v-model="model.hh"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="统一社会信用代码" prop="shxydm">
                <Input
                  v-model="model.shxydm"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="联系人" prop="lxr">
                <Input
                  v-model="model.lxr"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="联系电话" prop="lxdh">
                <Input
                  v-model="model.lxdh"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="所属行业" prop="sshy">
                <Input
                  v-model="model.sshy"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="所属区县" prop="ssqx">
                <Input
                  v-model="model.ssqx"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="用电地址" prop="yhdz">
                <Input
                  v-model="model.yhdz"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <div class="form-title">
            其他信息
          </div>
          <Row>
            <Col span="8">
              <FormItem label="合同容量" prop="htrl">
                <Input
                  :value="model.htrl + 'kVA'"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="电源配置" prop="dypz">
                <Input
                  v-model="model.dypz"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="供电电压" prop="gddy">
                <Input
                  v-model="model.gddy"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="8">
              <FormItem label="申报等级" prop="sbdj">
                <Input
                  v-model="model.sbdj"
                  style="width:100%"
                  type="text"
                  disabled
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="申请单上传" prop="fj">
                <div class="pdf-box">
                  <span>{{ model.fj && model.fj.split(',')[0] }}</span>
                  <a
                    v-if="model.fj"
                    target="_blank"
                    :href="model.fj && model.fj.split(',')[1]"
                    >预览</a
                  >
                </div>
              </FormItem>
            </Col>
          </Row>
          <div class="form-title" v-show="tab == '待处理' ? !disabled : true">
            审批结果
          </div>
          <Row v-show="tab == '待处理' ? !disabled : true">
            <Col span="8">
              <FormItem label="审批意见" prop="auditStatus">
                <Select
                  style="width: 170px"
                  v-model="model.auditStatus"
                  clearable
                  placeholder="请选择"
                >
                  <Option value="1">同意</Option>
                  <Option value="2">驳回</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row v-if="model.auditStatus == 2">
            <Col span="24">
              <FormItem label="说明" prop="result">
                <Input
                  style="width: 100%"
                  :autosize="true"
                  type="textarea"
                  placeholder="请输入"
                  v-model="model.result"
                ></Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
        <div v-show="tabIndex == 1">
          <div class="lc">
            <div class="lcItem" :key="index" v-for="(item, index) in lcList">
              <img
                v-if="item.cldz == '已驳回'"
                class="icon"
                src="@/assets/p6.png"
                alt=""
              />
              <img v-else class="icon" src="@/assets/p5.png" alt="" />
              <div class="lcItemt">
                <div class="lcItemtl">{{ item.clbt }}</div>
                <div class="lcItemtr">{{ item.cldz }}</div>
              </div>
              <div class="lcItemc">
                <img src="@/assets/p4.png" alt="" />
                <div class="lcIteml">
                  {{ item.cldz ? '提交时间' : '处理时间' }}
                </div>
                <div class="lcItemr">{{ item.clsj }}</div>
              </div>
              <div class="lcItemb" v-show="item.clbz">{{ item.clbz }}</div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="text-align: center;">
          <el-button @click="closeModel" style="width: 159px;" type=""
            >{{!disabled ? '取消' : '关闭'}}</el-button
          >
          <el-button
            v-if="!disabled"
            @click="save"
            style="width: 159px;margin-left: 30px"
            type="primary"
            >处理</el-button
          >
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import util from '@/libs/util.js'

export default {
  name: 'tqtPolicyConfig1Form',
  props: ['tab'],
  data() {
    return {
      tabArr: ['基本信息', '审批流程'],
      tabIndex: 0,
      id: null,
      loading: false,
      showModel: false,
      //表单参数
      model: {
        id: null,
        hm: null,
        hh: null,
        yhdz: null,
        shxydm: null,
        lxr: null,
        lxdh: null,
        sshy: null,
        ssqx: null,
        htrl: null,
        dypz: null,
        gddy: null,
        sbdj: null,
        fj: null,
        auditStatus: null,
        result: null
      },
      rules: {
        auditStatus: [{ required: true, message: '请选择', trigger: 'change' }],
        result: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      disabled: false,
      lcList: []
    }
  },
  methods: {
    initSumbit() {
      this.$emit('ok')
      this.restFormCyy1()
      this.showModel = false
    },
    restFormCyy1() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    tabClick(index) {
      this.tabIndex = index
    },
    openModel(id) {
      this.$set(this, 'tabIndex', this.$options.data.call(this).tabIndex)
      this.$set(this, 'lcList', this.$options.data.call(this).lcList)
      this.loading = true
      if (id) {
        this.id = id
        this.initForm()
      }
      // 重置实体类
      this.showModel = true
      this.restFormCyy1()
    },
    closeModel() {
      this.$set(this, 'model', this.$options.data.call(this).model)
      this.$set(this, 'id', this.$options.data.call(this).id)
      this.initSumbit()
    },
    //保存
    save() {
      console.log(123)
      this.loading = true
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.id) {
            this.update()
          }
        } else {
          this.loading = false
        }
      })
    },
    // 更新
    update() {
      let _this = this
      util.http
        .post('/api/dw/djsq/audit', {
          id: _this.id,
          auditStatus: _this.model.auditStatus,
          result: _this.model.result || null
        })
        .then(function(response) {
          _this.$Notice.success({
            title: '处理成功!'
          })
          _this.$emit('ok')
          _this.closeModel()
        })
        .catch(function(error) {
          _this.$Notice.error({
            title: '处理失败!'
          })
          _this.loding = false
          console.log(error)
        })
    },
    //渲染表单
    initForm() {
      let _this = this
      util.http
        .get('/api/dw/djsq/detail/' + this.id)
        .then(function(response) {
          if (response.data.result.status == 20) {
            response.data.result.auditStatus = '1'
          }
          if (response.data.result.status == 100) {
            response.data.result.auditStatus = '2'
          }
          _this.model = response.data.result
        })
        .catch(function(error) {
          _this.$Notice.error({
            title: '获取表单失败!'
          })
          console.log(error)
        })
      util.http
        .get('/api/dw/djsq/lcList/' + this.id)
        .then(function(response) {
          _this.lcList = response.data.result
          _this.loading = false
        })
        .catch(function(error) {
          _this.$Notice.error({
            title: '获取表单失败!'
          })
          _this.loading = false
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.button-area {
  display: flex;
  justify-content: flex-end;
}
.button-right-left {
  margin-right: 15px;
}
.button-right {
  margin-right: 55px;
}
.form-area {
  margin-top: 10px;
}
.form-flex {
  display: flex;
  justify-content: space-between;
}
.model-hidden {
  display: none;
}
.form-title {
  border-left: 6px solid #4a8ae9;
  padding-left: 20px;
  margin-bottom: 20px;
  font-weight: 700;
  font-size: 16px;
  .tab {
    display: flex;
    .tab-item {
      margin-right: 30px;
      padding-bottom: 6px;
      cursor: pointer;
    }
    .active {
      border-bottom: 3px solid #4a8ae9;
    }
  }
}
.pdf-box {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  padding: 6px 20px;
  font-size: 14px;
  color: #333333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    color: #1890ff;
  }
}
/deep/.ivu-form-item {
  width: 100%;
}

.lc {
  background: #ffffff;
  border-radius: 10px;
  padding: 36px 0 30px 75px;
  .lcItem {
    position: relative;
    padding-left: 76px;
    border-left: 1px solid #318ed6;
    padding-bottom: 113px;
    &:last-of-type {
      border: none;
      padding-bottom: 0;
    }
    .icon {
      width: 94px;
      height: 80px;
      position: absolute;
      left: 0;
      top: 0;
      transform: translateX(-43%);
    }
    .lcItemt {
      display: flex;
      align-items: center;
      margin-bottom: 11px;
      .lcItemtl {
        font-size: 24px;
        color: #191c3d;
      }
      .lcItemtr {
        margin-left: 10px;
        font-size: 18px;
        color: #33c821;
      }
    }
    .lcItemc {
      display: flex;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
      .lcIteml {
        font-size: 18px;
        color: #999;
        margin-right: 10px;
      }
      .lcItemr {
        font-size: 18px;
        color: #333;
      }
    }
    .lcItemb {
      margin-top: 26px;
      margin-right: 30px;
      padding: 20px 20px 45px;
      background: #f5f7fb;
      border-radius: 10px;
      color: rgba(25, 28, 61, 0.6);
      font-size: 18px;
    }
  }
}
</style>
